import { BrokenImage } from '@components/index';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 40px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  border-bottom: 1px solid #e6e8f0;
  padding-bottom: 24px;
  margin-bottom: 24px;

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: #fff;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  color: #1b203a;
`;

export const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: 1px solid #e6e8f0;
  margin: 24px 0;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &.lowerDiv {
    margin-left: 36px;
    justify-content: space-between;
    margin-top: 12px;
  }
`;

export const AssetImg = styled(BrokenImage)`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #d8dae5;
  background-color: #fff;

  margin-right: 12px;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1b203a;
`;

export const TriggeredByDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-height: 22px;
  background-color: #e6edff;
  border-radius: 4px;
  padding: 2px 4px;
  gap: 4px;

  color: #1371fe;
  font-size: 12px;
  font-weight: 500;
`;

export const AvatarImg = styled(BrokenImage)`
  width: 12px;
  height: 12px;
  border-radius: 6px;
`;

export const EventName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #696f8c;
`;

export const DateContent = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: #8f95b2;
`;

export const LoadMore = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: row;
`;

export const LoadingText = styled.div`
  border-radius: 8px;
  margin-right: 8px;
  border: none;
  font-size: 12px;
  color: #696f8c;
  text-align: center;
`;

export const LoadingImg = styled.img`
  height: 14px;
  width: 14px;
`;

export const ValueRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;

  column-gap: 12px;
`;

export const WrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
`;

interface IStatusValue {
  value?: string;
}

export const StatusValue = styled.div<IStatusValue>`
  display: flex;
  flex-direction: row;
  max-height: 22px;
  padding: 2px 6px;
  gap: 4px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  background-color: #e6edff;
  color: #1371fe;

  font-size: 12px;
  font-weight: 500;

  &.oldValue {
    text-decoration: line-through;
    background-color: #e6e8f0;
    color: #696f8c;
  }
`;

export const Circle = styled.div<IStatusValue>`
  width: 6.25px;
  height: 6.25px;
  border-radius: 3.125px;
  margin-top: -1px;

  // Temporary circle color until we get the right color values
  background-color: #1371fe;

  &.oldValue {
    background-color: #696f8c;
  }
`;

export const GenericTag = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #e6edff;
  color: #1371fe;
  height: 22px;
  border-radius: 15px;
  padding: 2px 8px;
  font-weight: 500;
  font-size: 12px;

  &.removed {
    text-decoration: line-through;
    background-color: #e6e8f0;
    color: #474d66;
  }
`;

export const IconWrapper = styled.div`
  margin: -3px 6.5px 0 6.5px;
`;

export const TextValues = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #1b203a;
  padding-top: 2px;
  word-break: break-all;

  &.removed {
    color: #8f95b2;
    text-decoration: line-through;
  }
`;

export const TriggeredByContent = styled.div`
  display: flex;
  border-radius: 4px;
  padding: 2px 4px;
  gap: 4px;
  background-color: #e6edff;
  max-width: fit-content;
  align-items: center;

  &.removed {
    background-color: #e6e8f0;
  }
`;

export const TriggeredByText = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #1371fe;

  &.removed {
    color: #696f8c;
    text-decoration: line-through;
  }
`;

export const CommentDiv = styled.div`
  border: 1px solid #e6e8f0;
  border-radius: 4px;
  background-color: #f5f7fb;
  color: #696f8c;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  margin-left: 36px;

  p,
  ul,
  ol {
    margin-bottom: 0;
  }

  em,
  u,
  strong,
  p,
  a {
    font-size: 12px;
  }

  ul,
  ol {
    margin-left: 20px;
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const SerialDiv = styled.div`
  background-color: #edeff4;
  color: #474d66;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 4px;
  border-radius: 4px;

  margin-left: 8px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 12px;
`;

export const LoadingRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  &.lowerDiv {
    margin-left: 36px;
    justify-content: space-between;
  }
`;

interface IDivider {
  height: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
